<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Dados da Cooperativa</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="closeForm()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline"
                >{{ type === "new" ? "Adicionar" : "Editar" }} Cooperativa</span
              >
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md3>
                    <v-text-field
                      label="Nome da Cooperativa*"
                      v-model="name"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, informe o nome da Cooperativa!',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      label="ID da Cooperativa*"
                      v-model="cooperativeId"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o ID da Cooperativa!',
                      ]"
                      required
                      :readonly="type === 'edit'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      label="CNPJ da Cooperativa*"
                      v-model="cnpj"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, informe o CNPJ da Cooperativa!',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-autocomplete
                      label="Estado de Atuação*"
                      :items="states"
                      :item-text="stateText"
                      item-value="initials"
                      v-model.lazy="state"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, informe o estado de atuação da Cooperativa!',
                      ]"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="Endereço"
                      v-model="adress"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="Município"
                      v-model="county"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="CEP"
                      v-model="cep"
                      mask="#####-###"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="Bairro"
                      v-model="district"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="Junta Comercial"
                      v-model="trade_board"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="URL do Estatuto da Cooperativa*"
                      v-model="terms_url"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="error" @click="closeForm()"> Fechar </v-btn>
              <v-btn
                flat
                color="success"
                @click="validate()"
                :loading="loading"
                :disabled="!valid"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/main";
import { mapActions, mapState } from "vuex";
import statesfile from "@/model/state";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      valid: false,
      rules: [],
      type: "new",
      name: null,
      cnpj: null,
      cooperativeId: null,
      state: null,
      adress: null,
      county: null,
      cep: null,
      district: null,
      trade_board: null,
      terms_url: null,
      states: statesfile.estados,
    };
  },
  computed: {
    ...mapState("configuration", ["loading"]),
  },
  mounted() {
    eventBus.$on("cooperativeForm", (obj) => {
      if (obj.type === "edit") {
        this.name = obj.data.name;
        this.cooperativeId = obj.data.id;
        this.cnpj = obj.data.cnpj || null;
        this.state = obj.data.state;
        this.adress = obj.data.adress || null;
        this.county = obj.data.county || null;
        this.cep = obj.data.cep || null;
        this.district = obj.data.district || null;
        this.trade_board = obj.data.trade_board || null;
        this.terms_url = obj.data.terms_url;
      } else if (obj.type === "new") {
        this.name = null;
        this.cooperativeId = null;
        this.cnpj = null;
        this.state = null;
        this.adress = null;
        this.county = null;
        this.cep = null;
        this.district = null;
        this.trade_board = null;
        this.terms_url = null;
      }
      this.type = obj.type;
      this.dialog = obj.status;
    });
  },
  methods: {
    ...mapActions("configuration", ["addCooperative", "updateCooperative"]),
    stateText(item) {
      return `${item.initials} - ${item.name}`;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        const data = {
          name: this.name,
          id: this.cooperativeId,
          cnpj: this.cnpj.replace(/\D/g, ""),
          state: this.state,
          adress: this.adress,
          county: this.county,
          cep: this.cep || null,
          district: this.district || null,
          trade_board: this.trade_board || null,
          terms_url: this.terms_url || null,
        };
        if (this.type === "new") {
          await this.addCooperative(data);
        } else if (this.type === "edit") {
          await this.updateCooperative(data);
        }
      }
      this.dialog = false;
      this.clearForm();
    },

    clearForm() {
      this.name = null;
      this.cooperativeId = null;
      this.cnpj = null;
      this.state = null;
      this.adress = null;
      this.county = null;
      this.cep = null;
      this.district = null;
      this.trade_board = null;
      this.terms_url = null;
      this.$refs.form.resetValidation();
    },

    closeForm() {
      this.dialog = false;
      this.clearForm();
    },
  },
};
</script>
